import { default as TierContentFeed } from './TierContentFeed';
import { default as TierContentFeedContainer } from './TierContentFeed.container';

export default TierContentFeedContainer(TierContentFeed);
